import React from 'react';
import * as S from './styles';

const Looks: React.FC = () => {
  return (
    <S.Container
      className="wow animate__animated animate__fadeIn"
      data-wow-duration="1s"
    >
      <S.Header>Looks</S.Header>
      <S.Wrapper>
        <S.Column>
          <div>
            <h6>Foto 1:</h6>
            <article>
              Óculos, Vogue Eyewear. Camisa, Chloé. Colete e bermuda, Gucci.
              Gravata, clipe de gravata, broche e jaqueta, tudo acervo Minha Avó
              Tinha. Anéis, Zai Brand.
            </article>
          </div>
          <div>
            <h6>Fotos 2 e 9:</h6>
            <article>
              Cardigan, Alessandra Rich. Camisa, Gloria Coelho. Shorts,
              Alexandra Rich. Cinto de couro, Gucci. Brinco, bolsa e cinto de
              corrente, tudo Fendi. Óculos, Vogue Eyewear.
            </article>
          </div>
          <div>
            <h6>Fotos 3 e 8:</h6>
            <article>
              Blazer e tricô, Moun off. Meia de látex, Lovetoys. Sapatos, Dolce
              & Gabbana. Óculos Vogue Eyewear.
            </article>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <h6>Foto 4:</h6>
            <article>
              Óculos, Vogue Eyewear. Blusa e calça, Louis Vuitton. Sapatos,
              Chanel.
            </article>
          </div>
          <div>
            <h6>Fotos 5 e 6:</h6>
            <article>
              Casaco, Louis Vuitton. Blazer e saia, Balmain. Camisa, Ines de la
              Fressange Paris. Gravata e lenço, acervo Minha Avó Tinha.
              Braceletes, Pakera Pakera. Colar, Nádia Gimenez. Anel, Zai Brand.
              Óculos, Vogue Eyewear. Meias, Miu Miu. Sapatos, Gucci.
            </article>
          </div>
          <div>
            <h6>Foto 7:</h6>
            <article>
              Look completo Chanel. Anel, Zai Brand. Brinco e piercing de nariz,
              Rebeca Furtado-Gold Diamond. Piercing de orelha, Gazin. Óculos,
              Vogue Eyewear.
            </article>
          </div>
        </S.Column>
      </S.Wrapper>
    </S.Container>
  );
};

export default Looks;
